import { providers } from '../../../providers';
import type { TersaImageModel } from '../../types';
import { defaultSizeNotes } from '../../tools';
import { general } from '../../general';

export const davinciModels: Record<string, TersaImageModel> = {
    davinci: {
        chef: providers.flowmuse,
        hideInstructions: true,
        providers: [
            {
                ...providers.flowmuse,
                model: general.image('davinci'),
                getCost: () => 0.01,
            },
        ],
        sizes: [],
        sizeNotes: defaultSizeNotes,
        resolutions: [],
        imagesCountOptions: [],
        precheck: [],
        supportsInput: ['i2p'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};